import { Button } from '@byecode/ui'
import { useAtomData } from '@lighthouse/shared'
import { nanoid } from '@lighthouse/tools'
import * as React from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { selectedBlockFormContainerAtom } from '@/atoms/page/state'

import { BlockSettingIcon } from '../styles'
import { RelativeFieldItem } from './RelativeFieldItem'

interface RelativeListConfigureProps {}

const SCxContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`
const SCxList = styled.div`
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
`
export const RelativeListConfigure: React.FunctionComponent<RelativeListConfigureProps> = () => {
    const { control, watch } = useFormContext()
    const { fields, remove, append } = useFieldArray({
        control,
        name: 'relativeFieldList',
        keyName: 'tid'
    })

    const bindDsId = watch('pointer') ?? ''

    // 直接从 blockContextIndex 获取父级 FormContainer
    const dsId = useAtomData(
        selectedBlockFormContainerAtom,
        React.useCallback(form => form?.config.pointer ?? '', [])
    )

    return (
        <SCxContainer>
            {fields.length > 0 && (
                <SCxList>
                    {fields.map((item, index) => (
                        <Controller
                            name={`relativeFieldList.${index}`}
                            key={item.tid}
                            render={({ field }) => (
                                <RelativeFieldItem
                                    index={index}
                                    dsId={dsId}
                                    bindDsId={bindDsId}
                                    value={field.value}
                                    onChange={field.onChange}
                                    onDelete={remove}
                                />
                            )}
                        />
                    ))}
                </SCxList>
            )}
            <Button
                radius="100px"
                style={{ width: 74 }}
                icon={<BlockSettingIcon color="var(--color-gray-500)" type="Add" />}
                onClick={() => append({ id: nanoid(10), fieldPointer: '', bindFieldPointer: '' })}
            >
                添加
            </Button>
        </SCxContainer>
    )
}
